import { atom } from 'nanostores';

import { api, type Plan } from '../lib/api';
import { messageOf } from './auth';

export const $plans = atom<Plan[]>([]);
export const $plansLoading = atom(false);
export const $plansError = atom<string | null>(null);

let inFlight: Promise<void> | null = null;

/**
 * Plans are immutable for the lifetime of a page view, so the first caller wins
 * and everyone else awaits the same promise instead of re-fetching.
 */
export function loadPlans(force = false): Promise<void> {
  if (!force && ($plans.get().length > 0 || inFlight)) {
    return inFlight ?? Promise.resolve();
  }
  $plansLoading.set(true);
  $plansError.set(null);

  inFlight = api
    .listPlans()
    .then((res) => {
      $plans.set(res.plans);
    })
    .catch((err: unknown) => {
      $plansError.set(messageOf(err));
    })
    .finally(() => {
      $plansLoading.set(false);
      inFlight = null;
    });

  return inFlight;
}
